import React from "react";
import { Chart } from "react-google-charts";

export const data = [
  ["Task", "Hours per Day"],
  ["Collection", 11],
  ["Delivery", 2],
  ["Depot", 2],
  ["Resource", 2],
  //["Sleep", 7], // CSS-style declaration
];

export const options = {
  //title: "My Daily Activities",
  pieHole: 0.4,
  is3D: false,
  legend: 'bottom',
  fontName: 'Roboto' , 
  fontSize: 13,
 // backgroundColor: '#ECECEC',
 colors: ['#2cb4d4','#1787b8','#255b98','#2f306d']
};

export default function DonutChart() {
  return (
    <Chart
      chartType="PieChart"
      width="100%"
      height="250px"
      data={data}
      options={options}
      
    />
  );
}
